import type { Task } from "../../../../shared/types";
import { getCategoryBadgeColor, getCategoryLabel, getCategoryDotColor } from "../../../../shared/stores/category-store";
import { getToday } from "../../../../shared/types/date-helpers";

interface TaskItemBadgesProps {
  readonly task: Task;
  readonly showCategory?: boolean;
}

export function TaskItemBadges({
  task,
  showCategory = false,
}: TaskItemBadgesProps) {
  const isOverdue =
    task.dueDate && task.dueDate < getToday() && task.status !== "done";

  return (
    <>
      {task.priority === "urgent" && (
        <div className="shrink-0 w-2 h-2 rounded-full bg-danger" title="Urgent" />
      )}
      {task.priority === "low" && (
        <div className="shrink-0 w-2 h-2 rounded-full bg-ink-faint/30" title="Basse priorité" />
      )}

      {isOverdue && (
        <>
          <span className="md:hidden text-[10px] px-1.5 py-0.5 bg-danger/10 text-danger rounded-full font-semibold leading-none" title="En retard">
            !
          </span>
          <span className="hidden md:inline text-[10px] px-1.5 py-0.5 bg-danger/10 text-danger rounded-full font-semibold">
            En retard
          </span>
        </>
      )}

      {showCategory && (
        <>
          {/* Mobile : dot de couleur */}
          <span className={`md:hidden shrink-0 w-2 h-2 rounded-full ${getCategoryDotColor(task.category)}`} title={getCategoryLabel(task.category)} />
          {/* Desktop : badge texte */}
          <span
            className={`hidden md:inline text-[10px] px-1.5 py-0.5 rounded-full ${getCategoryBadgeColor(task.category)}`}
          >
            {getCategoryLabel(task.category)}
          </span>
        </>
      )}
    </>
  );
}
